import { NoticeType } from '../enum';
import { BaseNotice } from '../types';
import * as Locale from '@/plugins/i18n';

export function createMemberJoinNotice(name: string, id = ''): BaseNotice {
  const message = Locale.i18n.t('notice.member.join', { name }) as string;
  return createNotice({
    message,
    type: NoticeType.MEMBER_JOINED,
    id: id || message,
  });
}

export function createMemberLeftNotice(name: string, id = ''): BaseNotice {
  const message = Locale.i18n.t('notice.member.leave', { name }) as string;
  return createNotice({
    message,
    type: NoticeType.MEMBER_LEFT,
    id: id || message,
  });
}

export function createNotice(partial: Partial<BaseNotice>): BaseNotice {
  return {
    type: NoticeType.GENERAL,
    message: '',
    timestamp: Date.now(),
    ...partial,
  };
}
